import { useEffect, useRef } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import { useDiscourseSession } from '@/hooks/use-discourse-classifiers'
import { syncThreadInUrl } from '@/threading/url-sync'

/**
 * Select the agent thread bound to a discourse session (support mode).
 *
 * Binds once per session so the operator can still switch threads by hand
 * while the tape keeps running.
 */
export function useDiscourseSupportThread(sessionId: string | undefined): string | null {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const boundSessionRef = useRef<string | null>(null)

  const { data } = useDiscourseSession(sessionId)
  const supportThreadId = data?.support_thread_id ?? null

  useEffect(() => {
    if (!sessionId || !supportThreadId) return
    if (boundSessionRef.current === sessionId) return
    boundSessionRef.current = sessionId
    if (searchParams.get('thread') === supportThreadId) return
    syncThreadInUrl(navigate, location.pathname, searchParams, supportThreadId, true)
  }, [sessionId, supportThreadId, navigate, location.pathname, searchParams])

  return supportThreadId
}
